import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ContractListItem } from '@app/features/contracts/contract.model';
import { ValidationRequestService } from '@app/features/contracts/validation/validation-request-service';

/** Ouvre l'historique (demandes de validation, revalorisations et avenants) d'un contrat. */
@Component({
  selector: 'app-button-contract-history',
  imports: [MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: './button-contract-history.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./button-contract-history.scss'],
})
export class ButtonContractHistory {
  contract = input.required<ContractListItem>();

  readonly validationRequestService = inject(ValidationRequestService);

  get hasHistory(): boolean {
    const contract = this.contract();
    return (
      (contract.validationRequests?.length ?? 0) > 0 ||
      (contract.salaryScaleContractUpdates?.length ?? 0) > 0 ||
      (contract.amendmentCount ?? 0) > 0
    );
  }

  get historyCount(): number {
    const contract = this.contract();
    return (
      (contract.validationRequests?.length ?? 0) +
      (contract.salaryScaleContractUpdates?.length ?? 0) +
      (contract.amendmentCount ?? 0)
    );
  }

  showValidationRequests(): void {
    this.validationRequestService.preview(this.contract());
  }
}
